import * as Sentry from "@sentry/browser";

export function updateFormioSubmission(
  formPath: string,
  submissionObj: any,
  handleWidgetError: React.Dispatch<React.SetStateAction<Error | null>>
): Promise<any> {
  return window.theme.ShopifyFormioProxy.updateFormioSubmission(
    formPath,
    submissionObj
  )
    .then((submission) => {
      if (!submission.data) {
        throw new Error(
          `Could not update submission: ${submissionObj._id} in form ${formPath}`
        );
      }
      return submission;
    })
    .catch((error) => {
      handleWidgetError(error);
      return Promise.reject(error);
    });
}

export function validateAcceptedCpl(
  cplFormPath: string,
  userEmail: any
): Promise<boolean> {
  const serviceUrl = `${window.FKL.yentaServicesApiUrl}/proxy`;
  return fetch(
    `${serviceUrl}/${cplFormPath}?email=${encodeURIComponent(
      window.theme.Utils.escapeRegExp(userEmail)
    )}`
  )
    .then((resp) => {
      return resp.json();
    })
    .then((submissions) => submissions.length > 0)
    .catch((error) => {
      Sentry.captureMessage(
        `CPL form validation error: ${error}`,
        Sentry.Severity.Error
      );
      return false;
    });
}
